/*
 * support for the slide out results navigation at mobile
 */
(function ($) {
    var clickEvent = Modernizr.touch === true ? 'touchend.results' : 'click.results';
    var $resultsPage = $('#results-page');

    //trigger mobile accordions for the shop lading pages.
    function bindShopLandingAccordion() {
        $resultsPage.find('.js-shop-landing-mobile-nav').mobileAccordion();
    }
    bindShopLandingAccordion();
    //on ajax refresh rebind the accordion for shop landing page nav
    $('#results-page').on('refresh.results', bindShopLandingAccordion);

    //trigger mobile accordions for the facets and set the sessions storage values.
    $resultsPage.mobileAccordion({
        selector: '.sidebar-inner .js-mobile-accordion-header',
        callback: function () {
            //this sets up the values to recover on refresh to keep accordions open
            var openAccordions = $('#results-sidebar').find('.js-mobile-accordion-header.active').map(function () {
                return '#' + this.id;
            })
                .get()
                .join(',');

            evo.sessionStorage.setItem('openAccordions', openAccordions);
        }
    });

    //need to hide the results sidebar when nav is open
    evo.$.body.on('mobileNavigation.close', function () {
        $('#results-sidebar').removeClass('hide-sidebar');
    });

    evo.$.body.on('mobileNavigation.open', function () {
        $('#results-sidebar').addClass('hide-sidebar');
    });

    evo.$.body.on('click.results', '#results-filter-button', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        evo.$.html.addClass('filters-active');
    });

    evo.$.body.on(clickEvent, '.js-results-sidebar-close', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        evo.$.html.removeClass('filters-active');
    });

    //--------------- Animate Number of Products Showing ---------
    var oldResultsCount = parseInt($("#results-count").data("count"));

    function resetCounter() {
        var $resultsCount = $("#results-count"),
            newCount = parseInt($resultsCount.data("count"));

        if (newCount && evo.$.html.hasClass('filters-active')) {
            // set prop 'counter' to current value
            $resultsCount.prop('Counter', oldResultsCount).animate({
                Counter: newCount
            }, {
                    duration: 667, // TODO duration as a function of difference
                    easing: 'swing', // TODO custom easing easeOutCirc is prefered
                    step: function (now) {
                        $(this).text(Math.ceil(now));
                    }
                });
        }
        oldResultsCount = newCount;
    }
    $('#results-page').on('refresh.results', resetCounter);
})(jQuery);